import { useState } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { DashboardFormWrapper } from '../../dashboard';
import { ClientsPage } from './ClientsComponents';
import { CompanyViewHeader, CompanyViewForm } from '../CompanyViewComponents';
import { useClientQuery } from '../../../hooks';
import { RoleGuard } from '../../../routes';

export const ClientsView = () => {
  const params: any = useParams();
  const { data, isFetching } = useClientQuery({ id: params.id });
  const [isEdit, setIsEdit] = useState(false);

  if (isFetching) return <></>;
  if (!data) return <Navigate to={'/dashboard/clients'} replace />;

  return (
    <RoleGuard roles={'adminRead'}>
      <ClientsPage>
        <CompanyViewHeader data={data} belongsTo={'CLIENT'} isEdit={isEdit} setIsEdit={setIsEdit} />
        <DashboardFormWrapper flow={'row'}>
          <CompanyViewForm data={data} />
          <CompanyViewHeader
            data={data}
            belongsTo={'CLIENT'}
            isEdit={isEdit}
            setIsEdit={setIsEdit}
            showOnlySubmit
          />
        </DashboardFormWrapper>
      </ClientsPage>
    </RoleGuard>
  );
};
